<template>
    <page :busy="busy" :tabs="tabs" :compact-mobile-view="true">
        <router-view @busy="handleBusy"></router-view>
    </page>
</template>

<script>
import Page from '../generic/page/page.vue';

export default {
    name: 'Document',
    components: {
        Page,
    },
    computed: {
        tabs() {
            return [
                {
                    title: `Report Templates`,
                    route: `/app/document/templates/`,
                    active: this.$route.path === `/app/document/templates/`,
                },
                {
                    title: `Rental Agreements Setup`,
                    route: `/app/document/agreements/`,
                    active: this.$route.path === `/app/document/agreements/`,
                },
            ];
        },
    },
    data() {
        return {
            busy: false,
        };
    },
    methods: {
        handleBusy(busy) {
            this.busy = busy;
        },
    },
};
</script>